import { render } from "./B2bPageDownloadInvoice.vue?vue&type=template&id=44e4e676&scoped=true&lang=pug"
import script from "./B2bPageDownloadInvoice.vue?vue&type=script&lang=js"
export * from "./B2bPageDownloadInvoice.vue?vue&type=script&lang=js"

import "./B2bPageDownloadInvoice.vue?vue&type=style&index=0&id=44e4e676&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e4e676"]])

export default __exports__